
import { PLACEHOLDER_DATA_URI } from '@/assets/placeholder'
import { sampleDominant, NEUTRAL_CARD_COLORS } from '@/utils/colorSample'

const HERO_INTERVAL = 4000

export default {
  name: 'HomeAggregate',
  data () {
    return {
      loading: true,
      sections: null, // /home-sections 原始响应（personalized/promotion/new）
      idx: 0, // 左侧轮播当前索引
      colors: {} // productId → { top, bottom, dark }（§29 采样缓存住 utils 层，这里只存展示态）
    }
  },
  computed: {
    pers () {
      const s = this.sections && this.sections.personalized
      return (s && s.products) || []
    },
    promo () {
      const s = this.sections && this.sections.promotion
      return (s && s.products) || []
    },
    fresh () {
      const s = this.sections && this.sections.new
      return (s && s.products) || []
    },
    hasContent () {
      return !!(this.pers.length || this.promo.length || this.fresh.length)
    }
  },
  created () {
    this.fetchSections()
  },
  activated () {
    // keep-alive 回页重试：仅失败（sections 未落地）才补拉，成功则不重复请求。
    // 首次挂载 created 与 activated 同帧连发——_fetching 互斥挡住第二发（§28 只 1 请求）
    if (!this.sections) this.fetchSections()
    else this.startTimer()
  },
  deactivated () {
    this.stopTimer()
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    async fetchSections () {
      if (this._fetching) return
      this._fetching = true
      try {
        const res = await this.axios.get('products/home-sections', { timeout: 4000 })
        if (res.data.code === 200) {
          this.sections = res.data.data
          this.idx = 0
          // §24 去重链第 1~3 环的 id 上报（个性化→促销→新品已示集），精选/更多好货据此跳过
          const shown = [...this.pers, ...this.promo, ...this.fresh].map(p => p.id)
          if (shown.length) this.$emit('shown', shown)
          this.applyColors()
          this.startTimer()
        }
      } catch (e) {
        /* 聚合区静默降级隐藏（v-if hasContent），不影响首页其余模块；
           失败也 emit 空 shown——释放瀑布流/精选的 §24 去重依赖等待，不空等超时 */
        this.$emit('shown', [])
      } finally {
        this._fetching = false
        this.loading = false
      }
    },
    // 主色采样（§10/§29）：utils 层按 URL 会话级缓存；这里并发采 6 张，逐张 $set 落地
    applyColors () {
      this.pers.forEach(p => {
        sampleDominant(this.mainImage(p), p.id).then(c => {
          if (this.colors[p.id] !== c) this.$set(this.colors, p.id, c)
        })
      })
    },
    heroColors (p) {
      return this.colors[p.id] || NEUTRAL_CARD_COLORS
    },
    heroStyle (p) {
      const c = this.heroColors(p)
      // 采样色实色兜底：图未载到时图区也不露白边/灰边（规则 6 边缘不露底）
      return { background: c.base }
    },
    veilStyle (p) {
      const c = this.heroColors(p)
      // 采样色渐变过渡带（配方在 utils/colorSample 单一来源，band-only 0→1 全高过渡）：
      // 只做图区与纯色实底条的交接，图片主体不被蒙色（高度由 .agg-hero-veil CSS 控制）
      return { background: c.veil }
    },
    solidStyle (p) {
      const c = this.heroColors(p)
      // 采样色纯色实底条：包住商品名（高度=名高，纯色上缘恒等于文字 top）；
      // 明暗按该色亮度（§13）
      return { background: c.base }
    },
    startTimer () {
      this.stopTimer()
      if (this.pers.length <= 1) return // 1 张无轮播语义
      this._timer = setInterval(() => {
        if (document.hidden) return // 后台标签页不推进（防漂移，同 Carousel 惯例）
        this.idx = (this.idx + 1) % this.pers.length
      }, HERO_INTERVAL)
    },
    stopTimer () {
      if (this._timer) { clearInterval(this._timer); this._timer = null }
    },
    // 主视觉取图优先级与首页商品卡一致：营销图 → 主图 → images[0] → 占位
    mainImage (p) {
      const raw = p.marketing_image || p.image || (Array.isArray(p.images) && p.images[0])
      return (raw && this.$img(raw)) || PLACEHOLDER_DATA_URI
    },
    onImgError (e) {
      e.target.src = PLACEHOLDER_DATA_URI
    },
    go (path) {
      this.$router.push(path)
    },
    toDetails (p) {
      this.$router.push({ path: '/details', query: { id: p.id } })
    }
  }
}
